import packageInfo from '../../package.json';

// interface Props {}

function HealthcheckContainer() {
  return (
    <div>
      {JSON.stringify({
        app_name: 'Panoee Studio Public Page',
        app_env: process.env.NODE_ENV,
        app_api: process.env.NEXT_PUBLIC_API_URL,
        app_version: packageInfo.version,
      })}
    </div>
  );
}

export default HealthcheckContainer;
